import { localizedMedia, localizedLink } from '../i18n/resources';
import { t, language } from '../i18n';
import {React, useEffect, useState} from "react";
import Navbar from "./Navbar";
import Package from "./Package";
import Footer from "./Footer";
import { Parallax } from 'react-parallax';
import InnerModal from "./InnerModal";
import InnerModalSzkolenie from "./InnerModalSzkolenie";
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import skpad1dOriginal from "../img/SKP_myjnia_desktop.png";
import skpad1mOriginal from "../img/SKP_myjnia_mobile.png";
import skpad2dOriginal from "../img/SKP_gasnica_desktop.png";
import skpad2mOriginal from "../img/SKP_gasnica_mobile.png";
import skpad3dOriginal from "../img/SKP_glaco_desktop.png";
import skpad3mOriginal from "../img/SKP_glaco_mobile.png";
import figad1dOriginal from "../img/Opony_cena_desktop.png";
import figad1mOriginal from "../img/Opony_cena_mobile.png";
import figad2dOriginal from "../img/Opony_hotel_desktop.png";
import figad2mOriginal from "../img/Opony_hotel_mobile.png";
import figad3dOriginal from "../img/Opony_mycie_desktop.png";
import figad3mOriginal from "../img/Opony_mycie_mobile.png";
import szbOriginal from "../img/nb.png";
import szkbgOriginal from "../img/head_desktop.jpg";
import michuOriginal from "../img/michu.png";
import szpozOriginal from "../img/sz_poz.mp4";
import ReactSimplyCarousel from 'react-simply-carousel';
import szkol1Original from "../img/szkol4.png";
import szkol2Original from "../img/szkol5.png";
import szkol3Original from "../img/szkol6.png";
import szkol4Original from "../img/szkol7.png";
import szkol5Original from "../img/szkol8.png";
import szkol6Original from "../img/szkol9.png";
import szkol7Original from "../img/szkol10.png";
import szkol8Original from "../img/szkol11.png";
import szkd1Original from "../img/szkd1.png";
import szkd2Original from "../img/szkd2.png";
import szkd3Original from "../img/szkd3.png";
import szkm1Original from "../img/szkm1.png";
import szkm2Original from "../img/szkm2.png";
import szkm3Original from "../img/szkm3.png";
import sgbOriginal from "../img/sgb.png";
import sgfOriginal from "../img/sgf.png";
import { useNavigate } from "react-router-dom";
import szkoleOriginal from "../img/szkole.png";
import pmp1Original from "../img/foto.jpg";
import pmp2Original from "../img/pmp2.png";
import pmp3Original from "../img/pmp3.png";
import indyOriginal from "../img/indy.png";
import koreOriginal from "../img/kore.png";
import korektaOriginal from "../img/korekta.png";
import stazOriginal from "../img/staz.png";
import lspOriginal from "../img/michszko.jpg";
import japoOriginal from "../img/japojapo.png";
import szkoldronOriginal from "../img/szkolenieGaraz.mp4";
import { NavLink } from 'react-router-dom';
import { BrowserRouter as Router, Switch, Route} from "react-router-dom";
import lspsl1Original from "../img/lsp_sl_1.png";
import lspsl2Original from "../img/lsp_sl_2.png";
import lspsl3Original from "../img/lsp_sl_3.png";
import lspsl4Original from "../img/lsp_sl_4.png";
import lspsl5Original from "../img/lsp_sl_5.png";
import lspsl6Original from "../img/lsp_sl_6.png";
import lspsl7Original from "../img/lsp_sl_7.png";
import lspsl8Original from "../img/lsp_sl_8.png";
import lspsl9Original from "../img/lsp_sl_9.png";
import lspsl10Original from "../img/lsp_sl_10.png";
import lspsl11Original from "../img/lsp_sl_11.png";
import lspsl12Original from "../img/lsp_sl_12.png";
import lspsl13Original from "../img/lsp_sl_13.png";
import lspsl14Original from "../img/lsp_sl_14.png";
import lspsl15Original from "../img/lsp_sl_15.png";
import lspsl16Original from "../img/lsp_sl_16.png";
import lspsl17Original from "../img/lsp_sl_17.png";
import lspnewimgOriginal from "../img/lsp_new_seb.jpg";

const skpad1d = localizedMedia(skpad1dOriginal, "SKP_myjnia_desktop.png");
const skpad1m = localizedMedia(skpad1mOriginal, "SKP_myjnia_mobile.png");
const skpad2d = localizedMedia(skpad2dOriginal, "SKP_gasnica_desktop.png");
const skpad2m = localizedMedia(skpad2mOriginal, "SKP_gasnica_mobile.png");
const skpad3d = localizedMedia(skpad3dOriginal, "SKP_glaco_desktop.png");
const skpad3m = localizedMedia(skpad3mOriginal, "SKP_glaco_mobile.png");
const figad1d = localizedMedia(figad1dOriginal, "Opony_cena_desktop.png");
const figad1m = localizedMedia(figad1mOriginal, "Opony_cena_mobile.png");
const figad2d = localizedMedia(figad2dOriginal, "Opony_hotel_desktop.png");
const figad2m = localizedMedia(figad2mOriginal, "Opony_hotel_mobile.png");
const figad3d = localizedMedia(figad3dOriginal, "Opony_mycie_desktop.png");
const figad3m = localizedMedia(figad3mOriginal, "Opony_mycie_mobile.png");
const szb = localizedMedia(szbOriginal, "nb.png");
const szkbg = localizedMedia(szkbgOriginal, "head_desktop.jpg");
const michu = localizedMedia(michuOriginal, "michu.png");
const szpoz = localizedMedia(szpozOriginal, "sz_poz.mp4");
const szkol1 = localizedMedia(szkol1Original, "szkol4.png");
const szkol2 = localizedMedia(szkol2Original, "szkol5.png");
const szkol3 = localizedMedia(szkol3Original, "szkol6.png");
const szkol4 = localizedMedia(szkol4Original, "szkol7.png");
const szkol5 = localizedMedia(szkol5Original, "szkol8.png");
const szkol6 = localizedMedia(szkol6Original, "szkol9.png");
const szkol7 = localizedMedia(szkol7Original, "szkol10.png");
const szkol8 = localizedMedia(szkol8Original, "szkol11.png");
const szkd1 = localizedMedia(szkd1Original, "szkd1.png");
const szkd2 = localizedMedia(szkd2Original, "szkd2.png");
const szkd3 = localizedMedia(szkd3Original, "szkd3.png");
const szkm1 = localizedMedia(szkm1Original, "szkm1.png");
const szkm2 = localizedMedia(szkm2Original, "szkm2.png");
const szkm3 = localizedMedia(szkm3Original, "szkm3.png");
const sgb = localizedMedia(sgbOriginal, "sgb.png");
const sgf = localizedMedia(sgfOriginal, "sgf.png");
const szkole = localizedMedia(szkoleOriginal, "szkole.png");
const pmp1 = localizedMedia(pmp1Original, "foto.jpg");
const pmp2 = localizedMedia(pmp2Original, "pmp2.png");
const pmp3 = localizedMedia(pmp3Original, "pmp3.png");
const indy = localizedMedia(indyOriginal, "indy.png");
const kore = localizedMedia(koreOriginal, "kore.png");
const korekta = localizedMedia(korektaOriginal, "korekta.png");
const staz = localizedMedia(stazOriginal, "staz.png");
const lsp = localizedMedia(lspOriginal, "michszko.jpg");
const japo = localizedMedia(japoOriginal, "japojapo.png");
const szkoldron = localizedMedia(szkoldronOriginal, "szkolenieGaraz.mp4");
const lspsl1 = localizedMedia(lspsl1Original, "lsp_sl_1.png");
const lspsl2 = localizedMedia(lspsl2Original, "lsp_sl_2.png");
const lspsl3 = localizedMedia(lspsl3Original, "lsp_sl_3.png");
const lspsl4 = localizedMedia(lspsl4Original, "lsp_sl_4.png");
const lspsl5 = localizedMedia(lspsl5Original, "lsp_sl_5.png");
const lspsl6 = localizedMedia(lspsl6Original, "lsp_sl_6.png");
const lspsl7 = localizedMedia(lspsl7Original, "lsp_sl_7.png");
const lspsl8 = localizedMedia(lspsl8Original, "lsp_sl_8.png");
const lspsl9 = localizedMedia(lspsl9Original, "lsp_sl_9.png");
const lspsl10 = localizedMedia(lspsl10Original, "lsp_sl_10.png");
const lspsl11 = localizedMedia(lspsl11Original, "lsp_sl_11.png");
const lspsl12 = localizedMedia(lspsl12Original, "lsp_sl_12.png");
const lspsl13 = localizedMedia(lspsl13Original, "lsp_sl_13.png");
const lspsl14 = localizedMedia(lspsl14Original, "lsp_sl_14.png");
const lspsl15 = localizedMedia(lspsl15Original, "lsp_sl_15.png");
const lspsl16 = localizedMedia(lspsl16Original, "lsp_sl_16.png");
const lspsl17 = localizedMedia(lspsl17Original, "lsp_sl_17.png");
const lspnewimg = localizedMedia(lspnewimgOriginal, "lsp_new_seb.jpg");

  const Szkolenie = (props) => {
  const {service, services} = props;
  const navigate = useNavigate();
  const [active, setActive] = useState();
  const [currentSelectedCat, setCurrentSelectedCat] = useState('Promo');
  let resBut = '';
  const [isShown, setIsShown] = useState(false);
  const handleClick = event => {
    setIsShown(current => !current);
  };
  const handleClickJaponskie = event => {
    window.location.href="/szkolenie/japonskie";
  };

  const handleClickPakiet = event => {
    window.location.href="/szkolenie/pakiet";
  };

  const handleClickKorekta = event => {
    window.location.href="/szkolenie/korekta";
  };
  const handleClickStaz = event => {
    window.location.href="/szkolenie/staz";
  };
  const handleClickIndywidualne = event => {
    window.location.href="/szkolenie/indywidualne";
  };

  const handleClickLsp = event => {
    window.location.href="/szkolenie/lsp";
  };
  
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const [dataSzkolenia, setDataSzkolenia] = useState(null);
  let pricePart = '';
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });
  }, []);

  const catCarouselFilter = (e, catToFilterName) => {
    console.log(e.target);
    // console.log(catToFilterName);
    setCurrentSelectedCat(catToFilterName)
};


  const [open, setOpen] = useState(false);
  const baseImgUrl = "https://test.cms.soft99.eu";
  const parallaxBgImg = szkbg;
  let mediaBox = 'media box';
  if (true) {
    resBut = <button className="nav-res-service" onClick={(e) => {
        e.preventDefault();
        const width = 900;
        const height = 800;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;

        window.open(
          localizedLink('https://szkolenia.soft99garage.pl/'),
          '_blank',
          `width=${width},height=${height},left=${left},top=${top},resizable,scrollbars,noopener,noreferrer`
        );
      }}>{t("Zapisz się")}</button>
    if(props.active == "indywidualne"){
      resBut = <a href="/kontakt"><button className="nav-res-service">{t("Wyślij zapytanie")}</button></a>
    } else if (props.active == "staz"){
      resBut = <a href="/kontakt"><button className="nav-res-service" >{t("Chce dołączyć")}</button></a>
    }
  };

  function formatPolishDate(dateStr) {
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Intl.DateTimeFormat(language === 'de' ? 'de-DE' : 'pl-PL', {
    day: 'numeric', month: 'long', year: 'numeric',
  }).format(new Date(year, month - 1, day));
}

 function TerminyLista({ terminy }) {
  if (terminy.length === 0) {
    return (
      <p>
        <a
          href={localizedLink("https://szkolenia.soft99garage.pl")}
          className="michtext openszko likepszkol"
          onClick={(e) => {
            const isMobile = window.innerWidth <= 768;
            if (isMobile) return; // pozwól otworzyć jak zwykły link

            e.preventDefault();
            const width = 900;
            const height = 800;
            const left = window.screenX + (window.outerWidth - width) / 2;
            const top = window.screenY + (window.outerHeight - height) / 2;

            window.open(
              e.currentTarget.href,
              '_blank',
              `width=${width},height=${height},left=${left},top=${top},resizable,scrollbars,noopener,noreferrer`
            );
          }}
        >{t("Obecnie brak terminów dla tego szkolenia.")}<br />{t("Sprawdź inne, które właśnie prowadzimy!")}</a>
      </p>
    );
  }

  return (
    <div>
      {terminy.map((termin) => (
        <p key={termin.id}>
          <a
            href={localizedLink(`https://szkolenia.soft99garage.pl/${termin.id}`)}
            className="michtext openszko likepszkol"
            onClick={(e) => {
              const isMobile = window.innerWidth <= 768;
              if (isMobile) return;

              e.preventDefault();
              const width = 900;
              const height = 800;
              const left = window.screenX + (window.outerWidth - width) / 2;
              const top = window.screenY + (window.outerHeight - height) / 2;

              window.open(
                e.currentTarget.href,
                '_blank',
                `width=${width},height=${height},left=${left},top=${top},resizable,scrollbars,noopener,noreferrer`
              );
            }}
          >{t("Poznań | ")}{formatPolishDate(termin.data)}
          </a>
        </p>
      ))}
    </div>
  );
}

function SzkolenieTerminy({ idSzkolenia }) {
  const [terminy, setTerminy] = useState([]);

  useEffect(() => {
    fetch(localizedLink(`https://szkolenia.soft99garage.pl/terminy_dla_szkolenia.php?id_szkolenia=${idSzkolenia}`))
      .then((res) => res.json())
      .then((data) => setTerminy(data));
  }, [idSzkolenia]);

  return <TerminyLista terminy={terminy} />;
}

  const OpiszSzkolenia = ({ idSzkolenia }) => {
  const [szkolenie, setSzkolenie] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!idSzkolenia) return;

    fetch(localizedLink(`https://szkolenia.soft99garage.pl/get_szkolenie.php?id=${idSzkolenia}`))
      .then((res) => res.json())
      .then((data) => {
        if (data.error) {
          setError(data.error);
        } else {
          setSzkolenie(data);
        }
      })
      .catch(() => setError(t("Błąd połączenia z serwerem")));
  }, [idSzkolenia]);

  if (error) return <div className="text-danger">{error}</div>;
  if (!szkolenie) return <div>{t("⏳ Ładowanie szkolenia...")}</div>;

  return (
      <div className="newszkol_desc" dangerouslySetInnerHTML={{ __html: szkolenie.opis }} />
  );
};

  const Main = (props) => {
    mediaBox = 
        <div className="service-media-part">
           <div className="service-media-part-single">
              {/*<video autoPlay muted loop>
                <source src={szkoldron} type="video/mp4"></source>
              </video>*/}
            </div>
        </div>
    return(
      <div className="service-main-content">
      <div className="container">
        <div className="row">
          <div className="col-lg-7">
            <p className="service-desc-par szdescpar">
              {/* <b>Pierwsze otwarte szkolenie z podstaw detailingu od Soft99!</b> */}{t("Chcesz podnieść swoje kwalifikacje? Chcesz rozbudować swoją wiedzę? Szukasz sposobu, by pracować efektywniej? A może po prostu chcesz rozwijać swoją pasję? Jeśli odpowiedziałeś na choćby jedno z tych pytań twierdząco, to oferta szkoleń w Soft99 Garage jest właśnie dla Ciebie!")}<br />
              <br />{t("Wspólnie z kadrą naszych ekspertów zyskasz wiedzę, zdobędziesz doświadczenie i umiejętność pracy w realnych warunkach. Oddajemy do Twojej dyspozycji 1000m2 nowoczesnej i doskonale wyposażonej przestrzeni, doskonałe materiały szkoleniowe, optymalne programy szkoleń i 100% naszego zaangażowania. Sprawdź ofertę, wybierz swoje szkolenie i zdobądź certyfikację Soft99 – działającej globalnie, uznanej marki z ponad 70-letnią historią.  ")}<br />
              <br />
              
            </p>
          </div>
          <div className="col-lg-5">
            {mediaBox}
          </div>              
        </div>
      </div>
    </div>
    )
  }

  const Pakiet = (props) => {
    mediaBox = 
        <div className="service-media-part">
           <div className="service-media-part-single">
              <video autoPlay muted loop>
                <source src={szpoz} type="video/mp4"></source>
              </video>
            </div>
            <div className="service-media-part-single">
              <br />
              <b className="nb">{t("Kiedy i gdzie?")}</b>
              <br />
              <br />
              {/* <p className="michtext openszko" onClick={() => { setDataSzkolenia('17.06.2023'); setOpen(true)}}>Poznań | 17.06.2023 + 01.07.2023 + 15.07.2023</p> */}
              <p className="michtext openszko" onClick={() => { setDataSzkolenia('17.06.2023'); setOpen(true)}}>{t("Poznań | 01.07.2023 + 15.07.2023")}</p>
              <br />
              <b className="nb">{t("Pakiet obejmuje:")}</b>
              <br />
              <br />
              <p className="michtext">
                {/* 17.06 - Japońskie mycie detailingowe<br /> */}{t("01.07 - Korekta lakieru od A do Z")}<br />{t("15.07 - Japońskie LSP")}<br />
              </p>
            </div>
            <div className="service-media-part-single">
              <br />
              <b className="nb">{t("Nasi detailerzy")}</b>
              <br />
              <br />
            </div>
            <div className="service-media-part-single">
              <img src={michu} alt=""></img>
              <p className="service-media-part-single-text black-version">{t("Michał Buchwald")}</p>
            </div>
            <div className="service-media-part-single">
              <p className="michtext">{t("Michał Buchwald jest ekspertem z ponad10-letnim doświadczeniem. Tworzy świat Soft99 w Europie od samego początku, czyli od 2014 roku. Jest Master Detailerem ")}{!isShown && (<span className="readmoreclick" onClick={handleClick}>{t("Czytaj dalej...")}</span>)}
              {isShown && (
              <span>{t("– człowiekiem, który wie absolutnie wszystko o produktach, zna wszystkie tajniki detailingu i to pod jego czujnym okiem rozwija się europejska oferta Soft99. Jako jeden z niewielu szkolił się w Japonii, pod okiem ekspertów z sieci studiów kosmetyki i detailingu Soft99 Autoservice / G’ZOX, a także przyglądał się procesowi produkcji w fabryce w Sanda. W Soft99 Garage dba o wszystkie aspekty działalności naszego centrum, zarządza zespołem, tworzy i rozwija ofertę, a także szkoli specjalistów. Pasję połączył z pracą i dlatego często możecie go spotkać w strefie detailingu, gdzie doradza klientom, nadzoruje realizację projektów, a często sam prowadzi najbardziej złożone i wymagające projekty.")}</span>)}<br />{isShown && (<span className="readmoreclick" onClick={handleClick}>{t("Pokaż mniej...")}</span>)}
              </p>
            </div>
        </div>
    return(
      <div className="service-main-content">
      <div className="container">
        <div className="row">
          <div className="col-lg-7">
            <p className="service-desc-par szdescpar">
              <b>{t("Pakiet szkoleń detailinowych od Soft99!")}</b>
              <br />
              <br />{t("Nie ma znaczenia, czy dopiero zaczynasz, czy chcesz rozwijać swoją wiedzę i doskonalić umiejętności. Wybierając pakiet 3 szkoleń w Soft99 Garage masz pewność, że bierzesz udział w kompleksowym, opracowanym od podstaw, nowoczesnym programie szkoleniowym pokrywającym wszystkie najważniejsze zagadnienia – od przygotowania do pracy, wyposażenia stanowiska, technik pracy, produktów, technologii, aż po optymalizację czasu. W jednym miejscu otrzymasz wszystko co niezbędne, by rozwinąć skrzydła w branży detailingu.")}<br />
              <br />{t("Soft99 Garage to także miejsce napędzane pasją i doświadczeniem ekspertów, którzy na co dzień realizują kompleksowe projekty detailingowe, śledzą trendy, wykorzystują wiedzę oraz dane centrum badawdzo-rozwojowego Soft99 Corporation i z sukcesem tworzą świat Soft99 w Europie. To także ludzie z misją, którzy chcą rozwijać talenty i wspierać innych na każdym etapie ich działalności – od hobbystów, aż po profesjonalistów.")}<br />
              <br />
              <b>{t("Ta oferta jest dla Ciebie jeśli chcesz:")}</b>
              <br />
              <br />
              <ul>
                  {/* <li>Oszczędzać! Kupując pakiet szkoleń dostajesz rabat 20%! W Twojej kieszeni zostanie aż 440 PLN!</li> */}
                  <li>{t("Oszczędzać! Kupując pakiet szkoleń dostajesz rabat 15%! W Twojej kieszeni zostanie aż 270 PLN!")}</li>
                  <br />
                  <li>{t("Poznać, zrozumieć i przećwiczyć wszystkie elementy procesu detailingu.")}</li>
                  <br />
                  <li>{t("Kształcić się w ramach przemyślanego i spójnego programu, w którym zagadnienia się wzajemnie uzupełniają.")}</li>
                  <br />
                  <li>{t("Cieszyć się niezmiennym, najwyższym standardem podczas wszystkich szkoleń.")}</li>
                  <br />
                  <li>{t("Poznać tajniki pracy z kompletnym japońskim systemem pracy oraz produktów.")}</li>
                  <br />
                  <li>{t("Pozyskiwać wiedzę od ekspertów z wieloletnim doświadczeniem w detailingu, ale także w detilingowym biznesie.")}</li>
                  <br />
              </ul>
              <b>{t("Dlaczego warto się szkolić w Soft99 Garage?")}</b>
              <br />
              <br />
              <ul>
                  <li>{t("Komfortowa, nowoczesna i doskonale wyposażona przestrzeń.")}</li>
                  <br />
                  <li>{t("Nowoczesne i optymalne programy szkoleń.")}</li>
                  <br />
                  <li>{t("Przejrzyste i zrozumiałe materiały dydaktyczne.")}</li>
                  <br />
                  <li>{t("Kameralna grupa, dzięki której otrzymasz maximum naszej uwagi.")}</li>
                  <br />
                  <li>{t("Stawiamy na praktykę i działamy w realnych warunkach.")}</li>
                  <br />
                  <li>{t("Kadra ekspertów doświadczonych w pracy i prowadzeniu detailingowego biznesu.")}</li>
                  <br />
                  <li>{t("Certyfikujemy jako Soft99 – globalna, uznana marka z 70-letnią historią.")}</li>
                  <br />
              </ul>
            </p>
          </div>
          <div className="col-lg-5">
            {mediaBox}
          </div>              
        </div>
        <div className="carousel-row">
        <ReactSimplyCarousel
  activeSlideIndex={activeSlideIndex}
  onRequestChange={setActiveSlideIndex}
  itemsToShow={1}
  itemsToScroll={1}
  forwardBtnProps={{
    className: "slideForBut",
    style: {
      alignSelf: 'center',
      background: 'transparent',
      border: 'none',
      borderRadius: '50%',
      color: 'white',
      cursor: 'pointer',
      fontSize: '10px',
      height: 16,
      lineHeight: 1,
      textAlign: 'center',
      width: 16,
    },
    children: <span><img src={sgf}></img></span>,
  }}
  backwardBtnProps={{
    className: "slideBacBut",
    style: {
      alignSelf: 'center',
      background: 'transparent',
      border: 'none',
      borderRadius: '50%',
      color: 'white',
      cursor: 'pointer',
      fontSize: '10px',
      height: 16,
      lineHeight: 1,
      textAlign: 'center',
      width: 16,
    },
    children: <span><img src={sgb}></img></span>,
  }}
  responsiveProps={[
    {
      itemsToShow: 3,
      itemsToScroll: 1,
      minWidth: 768,
    },
  ]}
  speed={400}
  easing="linear"
  >
  <img src={szkol1} className="slideItem" alt=""></img>
  <img src={szkol2} className="slideItem" alt=""></img>
  <img src={szkol3} className="slideItem" alt=""></img>
  <img src={szkol4} className="slideItem" alt=""></img>
  <img src={szkol5} className="slideItem" alt=""></img>
  <img src={szkol6} className="slideItem" alt=""></img>
  <img src={szkol7} className="slideItem" alt=""></img>
  <img src={szkol8} className="slideItem" alt=""></img>
  </ReactSimplyCarousel>
  <div className="aditionalszkoleniebutton">
    <button 
      className="nav-res-service "
      onClick={(e) => {

        e.preventDefault();
        const width = 900;
        const height = 800;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;

        window.open(
          e.currentTarget.href,
          '_blank',
          `width=${width},height=${height},left=${left},top=${top},resizable,scrollbars,noopener,noreferrer`
        );
      }}>{t("Zapisz się")}</button>
  </div>
        </div>
      </div>
    </div>
    )
  }

const Japonskie = (props) => {
  mediaBox = 
      <div className="service-media-part">
         <div className="service-media-part-single">
            <video autoPlay muted loop>
              <source src={szpoz} type="video/mp4"></source>
            </video>
          </div>
          <div className="service-media-part-single">
            <br />
            <b className="nb">{t("Kiedy i gdzie?")}</b>
            <br />
            <br />
            {/* <p className="michtext brakmiejsc">Poznań | 17 czerwca 2023 - Zapisy zakończone</p> */}
            {/* <p className="michtext brakmiejsc">Poznań | 2 grudnia 2023</p> */}
            {/* <p className="michtext brakmiejsc" >Poznań | 28 październik 2023 - Zapisy zakończone</p> */}

            {/* <p className="michtext openszko" onClick={() => { setDataSzkolenia('24.05.2025'); setOpen(true)}}>Poznań | 24 maja 2025</p> */}
            {/* <p className="michtext openszko" onClick={() => { setDataSzkolenia('14.06.2025'); setOpen(true)}}>Poznań | 14 czerwiec 2025</p> */}
            {/* <a href="https://szkolenia.soft99garage.pl/3" className="michtext openszko">Poznań | 19 lipiec 2025</a> */}
            <SzkolenieTerminy idSzkolenia={1} />
            <br />
          </div>
          <div className="service-media-part-single">
            <br />
            <b className="nb">{t("Nasi detailerzy")}</b>
            <br />
            <br />
          </div>
          <div className="service-media-part-single">
            <img src={michu} alt=""></img>
            <p className="service-media-part-single-text black-version">{t("Michał Buchwald")}</p>
          </div>
          <div className="service-media-part-single">
            <p className="michtext">{t("Michał Buchwald jest ekspertem z ponad10-letnim doświadczeniem. Tworzy świat Soft99 w Europie od samego początku, czyli od 2014 roku. Jest Master Detailerem ")}{!isShown && (<span className="readmoreclick" onClick={handleClick}>{t("Czytaj dalej...")}</span>)}
            {isShown && (
            <span>{t("– człowiekiem, który wie absolutnie wszystko o produktach, zna wszystkie tajniki detailingu i to pod jego czujnym okiem rozwija się europejska oferta Soft99. Jako jeden z niewielu szkolił się w Japonii, pod okiem ekspertów z sieci studiów kosmetyki i detailingu Soft99 Autoservice / G’ZOX, a także przyglądał się procesowi produkcji w fabryce w Sanda. W Soft99 Garage dba o wszystkie aspekty działalności naszego centrum, zarządza zespołem, tworzy i rozwija ofertę, a także szkoli specjalistów. Pasję połączył z pracą i dlatego często możecie go spotkać w strefie detailingu, gdzie doradza klientom, nadzoruje realizację projektów, a często sam prowadzi najbardziej złożone i wymagające projekty.")}</span>)}<br />{isShown && (<span className="readmoreclick" onClick={handleClick}>{t("Pokaż mniej...")}</span>)}
            </p>
          </div>
      </div>
  return(
    <div className="service-main-content">
    <div className="container">
      <div className="row">
        <div className="col-lg-7">
          <OpiszSzkolenia idSzkolenia={1} />
        </div>
        <div className="col-lg-5">
          {mediaBox}
        </div>              
      </div>
      <div className="carousel-row">
      <ReactSimplyCarousel
activeSlideIndex={activeSlideIndex}
onRequestChange={setActiveSlideIndex}
itemsToShow={1}
itemsToScroll={1}
forwardBtnProps={{
  className: "slideForBut",
  style: {
    alignSelf: 'center',
    background: 'transparent',
    border: 'none',
    borderRadius: '50%',
    color: 'white',
    cursor: 'pointer',
    fontSize: '10px',
    height: 16,
    lineHeight: 1,
    textAlign: 'center',
    width: 16,
  },
  children: <span><img src={sgf}></img></span>,
}}
backwardBtnProps={{
  className: "slideBacBut",
  style: {
    alignSelf: 'center',
    background: 'transparent',
    border: 'none',
    borderRadius: '50%',
    color: 'white',
    cursor: 'pointer',
    fontSize: '10px',
    height: 16,
    lineHeight: 1,
    textAlign: 'center',
    width: 16,
  },
  children: <span><img src={sgb}></img></span>,
}}
responsiveProps={[
  {
    itemsToShow: 3,
    itemsToScroll: 1,
    minWidth: 768,
  },
]}
speed={400}
easing="linear"
>
<img src={szkol1} className="slideItem" alt=""></img>
<img src={szkol2} className="slideItem" alt=""></img>
<img src={szkol3} className="slideItem" alt=""></img>
<img src={szkol4} className="slideItem" alt=""></img>
<img src={szkol5} className="slideItem" alt=""></img>
<img src={szkol6} className="slideItem" alt=""></img>
<img src={szkol7} className="slideItem" alt=""></img>
<img src={szkol8} className="slideItem" alt=""></img>
</ReactSimplyCarousel>
<div className="aditionalszkoleniebutton">
    <button 
      className="nav-res-service aditionalszkoleniebuttonbut"
      onClick={(e) => {

        e.preventDefault();
        const width = 900;
        const height = 800;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;

        window.open(
          localizedLink('https://szkolenia.soft99garage.pl/'),
          '_blank',
          `width=${width},height=${height},left=${left},top=${top},resizable,scrollbars,noopener,noreferrer`
        );
      }}>{t("Zapisz się")}</button>
  
  <br/><br/><b>{t("Byłeś już u nas na szkoleniu? Na każde kolejne dostajesz 15% rabatu!")}</b></div>
      </div>
    </div>
  </div>
  )
}


const Korekta = (props) => {
  mediaBox = 
      <div className="service-media-part">
         <div className="service-media-part-single">
              <img src={korekta} ></img>
          </div>
          <div className="service-media-part-single">
            <br />
            <b className="nb">{t("Kiedy i gdzie?")}</b>
            <br />
            <br />
            {/* <p className="michtext openszko">Poznań | 28 styczeń 2023 - Zapisy zakończone</p> */}
            {/* <p className="michtext brakmiejsc">Poznań | 1 lipca 2023 - Zapisy zakończone</p> */}
            {/* <p className="michtext brakmiejsc">Poznań | 19 listopad 2023 - Zapisy zakończone</p> */}
            
            {/* <p className="michtext brakmiejsc">Poznań | 9 grudnia 2023 - Zapisy zakończone</p> */}
            {/* <p className="michtext openszko" onClick={() => { setDataSzkolenia('28.06.2025'); setOpen(true)}}>Poznań | 28 czerwiec 2025</p>
            <p className="michtext openszko" onClick={() => { setDataSzkolenia('26.07.2025'); setOpen(true)}}>Poznań | 26 lipiec 2025</p> */}
            <SzkolenieTerminy idSzkolenia={2} />
            <br />
          </div>
          {/* <div className="service-media-part-single">
            <br />
            <b className="nb">Cena</b>
            <br />
            <br />
            <p className="michtext openszko">999zł</p>
            <br />
          </div> */}
          <div className="service-media-part-single">
            <br />
            <b className="nb">{t("Nasi detailerzy")}</b>
            <br />
            <br />
          </div>
          <div className="service-media-part-single">
            <img src={michu} alt=""></img>
            <p className="service-media-part-single-text black-version">{t("Michał Buchwald")}</p>
          </div>
          <div className="service-media-part-single">
            <p className="michtext">{t("Michał Buchwald jest ekspertem z ponad10-letnim doświadczeniem. Tworzy świat Soft99 w Europie od samego początku, czyli od 2014 roku. Jest Master Detailerem ")}{!isShown && (<span className="readmoreclick" onClick={handleClick}>{t("Czytaj dalej...")}</span>)}
            {isShown && (
            <span>{t("– człowiekiem, który wie absolutnie wszystko o produktach, zna wszystkie tajniki detailingu i to pod jego czujnym okiem rozwija się europejska oferta Soft99. Jako jeden z niewielu szkolił się w Japonii, pod okiem ekspertów z sieci studiów kosmetyki i detailingu Soft99 Autoservice / G’ZOX, a także przyglądał się procesowi produkcji w fabryce w Sanda. W Soft99 Garage dba o wszystkie aspekty działalności naszego centrum, zarządza zespołem, tworzy i rozwija ofertę, a także szkoli specjalistów. Pasję połączył z pracą i dlatego często możecie go spotkać w strefie detailingu, gdzie doradza klientom, nadzoruje realizację projektów, a często sam prowadzi najbardziej złożone i wymagające projekty.")}</span>)}<br />{isShown && (<span className="readmoreclick" onClick={handleClick}>{t("Pokaż mniej...")}</span>)}
            </p>
          </div>
      </div>
  return(
    <div className="service-main-content">
    <div className="container">
      <div className="row">
        <div className="col-lg-7">
          <OpiszSzkolenia idSzkolenia={2} />
        </div>
        <div className="col-lg-5">
          {mediaBox}
        </div>              
      </div>
      <div className="carousel-row">
      <ReactSimplyCarousel
activeSlideIndex={activeSlideIndex}
onRequestChange={setActiveSlideIndex}
itemsToShow={1}
itemsToScroll={1}
forwardBtnProps={{
  className: "slideForBut",
  style: {
    alignSelf: 'center',
    background: 'transparent',
    border: 'none',
    borderRadius: '50%',
    color: 'white',
    cursor: 'pointer',
    fontSize: '10px',
    height: 16,
    lineHeight: 1,
    textAlign: 'center',
    width: 16,
  },
  children: <span><img src={sgf}></img></span>,
}}
backwardBtnProps={{
  className: "slideBacBut",
  style: {
    alignSelf: 'center',
    background: 'transparent',
    border: 'none',
    borderRadius: '50%',
    color: 'white',
    cursor: 'pointer',
    fontSize: '10px',
    height: 16,
    lineHeight: 1,
    textAlign: 'center',
    width: 16,
  },
  children: <span><img src={sgb}></img></span>,
}}
responsiveProps={[
  {
    itemsToShow: 3,
    itemsToScroll: 1,
    minWidth: 768,
  },
]}
speed={400}
easing="linear"
>
<img src={szkol1} className="slideItem" alt=""></img>
<img src={szkol2} className="slideItem" alt=""></img>
<img src={szkol3} className="slideItem" alt=""></img>
<img src={szkol4} className="slideItem" alt=""></img>
<img src={szkol5} className="slideItem" alt=""></img>
<img src={szkol6} className="slideItem" alt=""></img>
<img src={szkol7} className="slideItem" alt=""></img>
<img src={szkol8} className="slideItem" alt=""></img>
</ReactSimplyCarousel>
<div className="aditionalszkoleniebutton">    <button 
      className="nav-res-service aditionalszkoleniebuttonbut"
      onClick={(e) => {

        e.preventDefault();
        const width = 900;
        const height = 800;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;

        window.open(
          localizedLink('https://szkolenia.soft99garage.pl/'),
          '_blank',
          `width=${width},height=${height},left=${left},top=${top},resizable,scrollbars,noopener,noreferrer`
        );
      }}>{t("Zapisz się")}</button><br/><br/><b>{t("Byłeś już u nas na szkoleniu? Na każde kolejne dostajesz 15% rabatu!")}</b></div>
      </div>
    </div>
  </div>
  )
}

const Lsp = (props) => {
  mediaBox = 
      <div className="service-media-part">
         <div className="service-media-part-single">
              <img src={lspnewimg} ></img>
          </div>
          <div className="service-media-part-single">
            <br />
            <b className="nb">{t("Kiedy i gdzie?")}</b>
            <br />
            <br />
            {/* <p className="michtext openszko">Poznań | 28 styczeń 2023 - Zapisy zakończone</p> */}
            {/* <p className="michtext brakmiejsc">Poznań | 25 listopad 2023 - Zapisy zakończone</p> */}
            {/* <p className="michtext brakmiejsc">Poznań | 10 maj 2025</p> */}
            {/* <p className="michtext openszko" onClick={() => { setDataSzkolenia('07.06.2025'); setOpen(true)}}>Poznań | 7 czerwiec 2025</p>
            <p className="michtext openszko" onClick={() => { setDataSzkolenia('12.07.2025'); setOpen(true)}}>Poznań | 12 lipiec 2025</p> */}
            <SzkolenieTerminy idSzkolenia={3} />
            <br />
          </div>
          {/* <div className="service-media-part-single">
            <br />
            <b className="nb">Cena</b>
            <br />
            <br />
            <p className="michtext openszko">999zł</p>
            <br />
          </div> */}
          <div className="service-media-part-single">
            <br />
            <b className="nb">{t("Nasi detailerzy")}</b>
            <br />
            <br />
          </div>
          <div className="service-media-part-single">
            <img src={michu} alt=""></img>
            <p className="service-media-part-single-text black-version">{t("Michał Buchwald")}</p>
          </div>
          <div className="service-media-part-single">
            <p className="michtext">{t("Michał Buchwald jest ekspertem z ponad 10-letnim doświadczeniem. Tworzy świat Soft99 w Europie od samego początku, czyli od 2014 roku. Jest Master Detailerem ")}{!isShown && (<span className="readmoreclick" onClick={handleClick}>{t("Czytaj dalej...")}</span>)}
            {isShown && (
            <span>{t("– człowiekiem, który wie absolutnie wszystko o produktach, zna wszystkie tajniki detailingu i to pod jego czujnym okiem rozwija się europejska oferta Soft99. Jako jeden z niewielu szkolił się w Japonii, pod okiem ekspertów z sieci studiów kosmetyki i detailingu Soft99 Autoservice / G’ZOX, a także przyglądał się procesowi produkcji w fabryce w Sanda. W Soft99 Garage dba o wszystkie aspekty działalności naszego centrum, zarządza zespołem, tworzy i rozwija ofertę, a także szkoli specjalistów. Pasję połączył z pracą i dlatego często możecie go spotkać w strefie detailingu, gdzie doradza klientom, nadzoruje realizację projektów, a często sam prowadzi najbardziej złożone i wymagające projekty.")}</span>)}<br />{isShown && (<span className="readmoreclick" onClick={handleClick}>{t("Pokaż mniej...")}</span>)}
            </p>
          </div>
      </div>
  return(
    <div className="service-main-content">
    <div className="container">
      <div className="row">
        <div className="col-lg-7">
          <OpiszSzkolenia idSzkolenia={3} />
        </div>
        <div className="col-lg-5">
          {mediaBox}
        </div>              
      </div>
      <div className="carousel-row">
      <ReactSimplyCarousel
activeSlideIndex={activeSlideIndex}
onRequestChange={setActiveSlideIndex}
itemsToShow={1}
itemsToScroll={1}
forwardBtnProps={{
  className: "slideForBut",
  style: {
    alignSelf: 'center',
    background: 'transparent',
    border: 'none',
    borderRadius: '50%',
    color: 'white',
    cursor: 'pointer',
    fontSize: '10px',
    height: 16,
    lineHeight: 1,
    textAlign: 'center',
    width: 16,
  },
  children: <span><img src={sgf}></img></span>,
}}
backwardBtnProps={{
  className: "slideBacBut",
  style: {
    alignSelf: 'center',
    background: 'transparent',
    border: 'none',
    borderRadius: '50%',
    color: 'white',
    cursor: 'pointer',
    fontSize: '10px',
    height: 16,
    lineHeight: 1,
    textAlign: 'center',
    width: 16,
  },
  children: <span><img src={sgb}></img></span>,
}}
responsiveProps={[
  {
    itemsToShow: 3,
    itemsToScroll: 1,
    minWidth: 768,
  },
]}
speed={400}
easing="linear"
>
<img src={lspsl1} className="slideItem" alt=""></img>
<img src={lspsl2} className="slideItem" alt=""></img>
<img src={lspsl3} className="slideItem" alt=""></img>
<img src={lspsl4} className="slideItem" alt=""></img>
<img src={lspsl5} className="slideItem" alt=""></img>
<img src={lspsl6} className="slideItem" alt=""></img>
<img src={lspsl7} className="slideItem" alt=""></img>
<img src={lspsl8} className="slideItem" alt=""></img>
<img src={lspsl9} className="slideItem" alt=""></img>
<img src={lspsl10} className="slideItem" alt=""></img>
<img src={lspsl11} className="slideItem" alt=""></img>
<img src={lspsl12} className="slideItem" alt=""></img>
<img src={lspsl13} className="slideItem" alt=""></img>
<img src={lspsl14} className="slideItem" alt=""></img>
<img src={lspsl15} className="slideItem" alt=""></img>
<img src={lspsl16} className="slideItem" alt=""></img>
<img src={lspsl17} className="slideItem" alt=""></img>
</ReactSimplyCarousel>
<div className="aditionalszkoleniebutton">    <button 
      className="nav-res-service aditionalszkoleniebuttonbut"
      onClick={(e) => {


        e.preventDefault();
        const width = 900;
        const height = 800;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;

        window.open(
          localizedLink('https://szkolenia.soft99garage.pl/'),
          '_blank',
          `width=${width},height=${height},left=${left},top=${top},resizable,scrollbars,noopener,noreferrer`
        );
      }}>{t("Zapisz się")}</button><br/><br/><b>{t("Byłeś już u nas na szkoleniu? Na każde kolejne dostajesz 15% rabatu!")}</b></div>
      </div>
    </div>
  </div>
  )
}

const Indywidualne = (props) => {
  mediaBox = 
      <div className="service-media-part">
         <div className="service-media-part-single">
            <video autoPlay muted loop>
              <source src={szpoz} type="video/mp4"></source>
            </video>
          </div>
      </div>
  return(
    <div className="service-main-content">
    <div className="container">
      <div className="row">
        <div className="col-lg-7">
          <p className="service-desc-par szdescpar">
            {/* <b>Pierwsze otwarte szkolenie z podstaw detailingu od Soft99!</b> */}{t("Gotowe programy szkoleń nie odpowiadają Twoim oczekiwaniom i masz specyficzne potrzeby w zakresie pozyskania wiedzy? A może poszukujesz szkoleń dla swoich pracowników, które obejmą konkretne zagadnienia?  Koniecznie skontaktuj się z nami! ")}<br />
            <br></br>{t("Prowadzimy indywidualne szkolenia dla osób lub grup tworząc programy od podstaw, uszyty na miarę Twoich oczekiwań. Realizujemy działania edukacyjne dla zespołów myjni, car-spa i studiów detailingu na każdym poziomie zaawansowania – od wdrożenia, przez szlifowanie umiejętności, aż po prowadzenie złożonych projektów detailingowych. ")}<br />
            <a href="/kontakt"><button className="nav-res-service">{t("WYŚLIJ ZAPYTANIE")}</button></a><br /><br />
          </p>
        </div>
        <div className="col-lg-5">
        <div className="service-media-part-single">
            <b className="nb">{t("Nasi detailerzy")}</b>
            <br />
            <br />
          </div>
          <div className="service-media-part-single">
            <img src={michu} alt=""></img>
            <p className="service-media-part-single-text black-version">{t("Michał Buchwald")}</p>
          </div>
          <div className="service-media-part-single">
            <p className="michtext">{t("Michał Buchwald jest ekspertem z ponad10-letnim doświadczeniem. Tworzy świat Soft99 w Europie od samego początku, czyli od 2014 roku. Jest Master Detailerem ")}{!isShown && (<span className="readmoreclick" onClick={handleClick}>{t("Czytaj dalej...")}</span>)}
            {isShown && (
            <span>{t("– człowiekiem, który wie absolutnie wszystko o produktach, zna wszystkie tajniki detailingu i to pod jego czujnym okiem rozwija się europejska oferta Soft99. Jako jeden z niewielu szkolił się w Japonii, pod okiem ekspertów z sieci studiów kosmetyki i detailingu Soft99 Autoservice / G’ZOX, a także przyglądał się procesowi produkcji w fabryce w Sanda. W Soft99 Garage dba o wszystkie aspekty działalności naszego centrum, zarządza zespołem, tworzy i rozwija ofertę, a także szkoli specjalistów. Pasję połączył z pracą i dlatego często możecie go spotkać w strefie detailingu, gdzie doradza klientom, nadzoruje realizację projektów, a często sam prowadzi najbardziej złożone i wymagające projekty.")}</span>)}<br />{isShown && (<span className="readmoreclick" onClick={handleClick}>{t("Pokaż mniej...")}</span>)}
            </p>
          </div>
        </div>              
      </div>
    </div>
  </div>
  )
}
const Staz = (props) => {
  mediaBox = 
      <div className="service-media-part">
         <div className="service-media-part-single">
            <video autoPlay muted loop>
              <source src={szpoz} type="video/mp4"></source>
            </video>
          </div>
      </div>
  return(
    <div className="service-main-content">
    <div className="container">
      <div className="row">
        <div className="col-lg-7">
          <p className="service-desc-par szdescpar">
            {/* <b>Pierwsze otwarte szkolenie z podstaw detailingu od Soft99!</b> */}{t("Jeśli poszukujesz swojej pierwszej pracy i marzysz o karierze w branży kosmetyki samochodowej, to tę przygodę warto zacząć w Soft99 Garage. Dołącz do naszego zespołu jako stażysta, a my wdrożymy Cię w procedury, pokażemy jak funkcjonuje największe w tej części Europy, kompleksowe centrum samochodowej kosmetyki i nauczymy Cię podstaw pracy.  ")}<br />
            <br />{t("Z nami zyskasz pierwsze doświadczenia i rozwiniesz skrzydła pod szyldem jednej z największych, globalnych i uznanych marek w segmencie car-care, czyli Soft99!  ")}<br />
            <br /><a href="/kontakt"><button className="nav-res-service">{t("CHCE DOŁĄCZYĆ")}</button></a><br /><br />
          </p>
        </div>
        <div className="col-lg-5">
        <div className="service-media-part-single">
            <b className="nb">{t("Nasi detailerzy")}</b>
            <br />
            <br />
          </div>
          <div className="service-media-part-single">
            <img src={michu} alt=""></img>
            <p className="service-media-part-single-text black-version">{t("Michał Buchwald")}</p>
          </div>
          <div className="service-media-part-single">
            <p className="michtext">{t("Michał Buchwald jest ekspertem z ponad10-letnim doświadczeniem. Tworzy świat Soft99 w Europie od samego początku, czyli od 2014 roku. Jest Master Detailerem ")}{!isShown && (<span className="readmoreclick" onClick={handleClick}>{t("Czytaj dalej...")}</span>)}
            {isShown && (
            <span>{t("– człowiekiem, który wie absolutnie wszystko o produktach, zna wszystkie tajniki detailingu i to pod jego czujnym okiem rozwija się europejska oferta Soft99. Jako jeden z niewielu szkolił się w Japonii, pod okiem ekspertów z sieci studiów kosmetyki i detailingu Soft99 Autoservice / G’ZOX, a także przyglądał się procesowi produkcji w fabryce w Sanda. W Soft99 Garage dba o wszystkie aspekty działalności naszego centrum, zarządza zespołem, tworzy i rozwija ofertę, a także szkoli specjalistów. Pasję połączył z pracą i dlatego często możecie go spotkać w strefie detailingu, gdzie doradza klientom, nadzoruje realizację projektów, a często sam prowadzi najbardziej złożone i wymagające projekty.")}</span>)}<br />{isShown && (<span className="readmoreclick" onClick={handleClick}>{t("Pokaż mniej...")}</span>)}
            </p>
          </div>
        </div>             
      </div>
    </div>
  </div>
  )
}
  return(
        <section>
          <Modal open={open} onClose={() => setOpen(false)} center>
            <InnerModalSzkolenie dataszko={dataSzkolenia}/>
          </Modal>
          <header>
            <Navbar services={services} service={service} szkoleniejest={true} />
          </header>
          <Parallax bgImage={parallaxBgImg} strength={500} bgClassName="parallax-bg-services">
          <div className="service-top-hero">
            <div className="service-top-hero-tag">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    {/* <p>{service.tag}</p> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="service-top-hero-bottom-part">
              <div className="service-top-hero-title">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <h2>{t("Szkolenia")}</h2>
                    </div>
                  </div>
                </div>
              </div>
              {props.active === "japonskie" && 
              <div className="service-top-hero-black-bottom">
                <div className="container dontshowmeonmobile">
                  <div className="row">
                    <div className="col-lg-6 col-sm-8">
                      <p className="service-top-hero-black-bottom-subtitle">{t("Japońskie mycie detailingowe")}</p>
                      <span className="service-top-hero-black-bottom-price">{t("399 zł")}</span>
                    </div>
                    <div className="col-lg-6 col-sm-4">
                      {resBut}
                    </div>
                  </div>
                </div>
              
                <div className="container showmeonlyonmobile">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="service-top-mob-left tszctap">
                        <p>{t("Japońskie mycie ")}<br></br>{t("detailingowe")}</p>
                        <span className="service-top-hero-black-bottom-price">{t("399 zł")}</span>
                        {/* <span className="pst">899 zł</span> <span className="pr">399 zł</span> */}
                      </div>
                      <div className="service-top-mob-right tszcta">
                        {resBut}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            {props.active === "pakiet" && 
              <div className="service-top-hero-black-bottom">
                <div className="container dontshowmeonmobile">
                  <div className="row">
                    <div className="col-lg-6 col-sm-8">
                      <p className="service-top-hero-black-bottom-subtitle">{t("Pakiet szkoleń w Soft99 Garage")}</p>
                       {/* <span className="pst">899 zł</span> <span className="pr">399 zł</span> */}
                       {/* <span className="service-top-hero-black-bottom-price pst">2197 zł</span> <span className="service-top-hero-black-bottom-price pr">1757 zł</span> <span></span> */}
                       <span className="service-top-hero-black-bottom-price pst">{t("1798 zł")}</span> <span className="service-top-hero-black-bottom-price pr">{t("1528 zł")}</span> <span></span>
                    </div>
                    <div className="col-lg-6 col-sm-4">
                      {resBut}
                    </div>
                  </div>
                </div>
              
                <div className="container showmeonlyonmobile">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="service-top-mob-left tszctap">
                        <p>{t("Pakiet szkoleń w Soft99 Garage")}</p>
                        <span className="service-top-hero-black-bottom-price pst">{t("1798 zł")}</span> <span className="service-top-hero-black-bottom-price pr">{t("1528 zł")}</span> <span></span>
                        {/* <span className="service-top-hero-black-bottom-price pst">2197 zł</span> <span className="service-top-hero-black-bottom-price pr">1757 zł</span> <span></span> */}
                      </div>
                      <div className="service-top-mob-right tszcta">
                        {resBut}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            {props.active === "korekta" && 
              <div className="service-top-hero-black-bottom">
                <div className="container dontshowmeonmobile">
                  <div className="row">
                    <div className="col-lg-6 col-sm-8">
                      <p className="service-top-hero-black-bottom-subtitle">{t("Korekta lakieru od A do Z")}</p>
                      <span className="service-top-hero-black-bottom-price">{t("999 zł")}</span> <span></span>
                    </div>
                    <div className="col-lg-6 col-sm-4">
                      {resBut}
                    </div>
                  </div>
                </div>
              
                <div className="container showmeonlyonmobile">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="service-top-mob-left tszctap">
                        <p>{t("Korekta lakieru od A do Z")}</p>
                        <span className="service-top-hero-black-bottom-price">{t("999 zł")}</span>
                      </div>
                      <div className="service-top-mob-right tszcta">
                        {resBut}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            {props.active === "indywidualne" && 
              <div className="service-top-hero-black-bottom">
                <div className="container dontshowmeonmobile">
                  <div className="row">
                    <div className="col-lg-6 col-sm-8">
                      <p className="service-top-hero-black-bottom-subtitle">{t("Szkolenie indywidualne")}</p>
                      <span className="service-top-hero-black-bottom-price">{t("Do uzgodnienia")}</span>
                    </div>
                    <div className="col-lg-6 col-sm-4">
                      {resBut}
                    </div>
                  </div>
                </div>
              
                <div className="container showmeonlyonmobile">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="service-top-mob-left tszctap">
                        <p>{t("Szkolenie indywidualne")}</p>
                        <span className="service-top-hero-black-bottom-price">{t("Do uzgodnienia")}</span>
                        {/* <span className="pst">899 zł</span> <span className="pr">399 zł</span> */}
                      </div>
                      <div className="service-top-mob-right tszcta">
                        {resBut}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            {props.active === "lsp" && 
              <div className="service-top-hero-black-bottom">
                <div className="container dontshowmeonmobile">
                  <div className="row">
                    <div className="col-lg-6 col-sm-8">
                      <p className="service-top-hero-black-bottom-subtitle">{t("Japońskie LSP, czyli zabezpieczenie powierzchni z Soft99")}</p>
                      <span className="service-top-hero-black-bottom-price">{t("799 zł")}</span>
                    </div>
                    <div className="col-lg-6 col-sm-4">
                      {resBut}
                    </div>
                  </div>
                </div>
              
                <div className="container showmeonlyonmobile">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="service-top-mob-left tszctap">
                        <p>{t("Japońskie LSP, czyli zabezpieczenie powierzchni z Soft99")}</p>
                        <span className="service-top-hero-black-bottom-price">{t("799 zł")}</span>
                        {/* <span className="pst">899 zł</span> <span className="pr">399 zł</span> */}
                      </div>
                      <div className="service-top-mob-right tszcta">
                        {resBut}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            {props.active === "staz" && 
              <div className="service-top-hero-black-bottom">
                <div className="container dontshowmeonmobile">
                  <div className="row">
                    <div className="col-lg-6 col-sm-8">
                      <p className="service-top-hero-black-bottom-subtitle">{t("Praca w Soft99!")}</p>
                      {/* <span className="service-top-hero-black-bottom-price">Do uzgodnienia</span> */}
                    </div>
                    <div className="col-lg-6 col-sm-4">
                      {resBut}
                    </div>
                  </div>
                </div>
              
                <div className="container showmeonlyonmobile">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="service-top-mob-left tszctap">
                        <p>{t("Praca w Soft99!")}</p>
                        {/* <span className="service-top-hero-black-bottom-price">899 zł</span> */}
                        {/* <span className="pst">899 zł</span> <span className="pr">399 zł</span> */}
                      </div>
                      <div className="service-top-mob-right tszcta">
                        {resBut}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            </div>
          </div>
          </Parallax>
          <div>
          <section className="black-section homepage-welcome-screen">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-sm-12 cat-box">
                            <div className="cat-carousel">

                                <div className="cat-carousel-cards row">
                                    <div className="cat-carousel-card-szkolenie col-lg-3 col-md-3 col-sm-3" onClick={handleClickJaponskie} style={{display: ('Promo' === currentSelectedCat || currentSelectedCat === 'Wszystko') ? 'initial' : 'none' }}>
                                        <div className="cat-carousel-card-inner-szkolenie">
                                            <div className="cat-carousel-card-img-szkolenie">
                                                <img src={japo} alt="" />
                                            </div>
                                            
                                            <div className="cat-carousel-card-title-szkolenie">
                                                <p>{t("Japońskie mycie detailingowe")}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="cat-carousel-card-szkolenie col-lg-3 col-md-3 col-sm-3" onClick={handleClickKorekta} style={{display: ('Promo' === currentSelectedCat || currentSelectedCat === 'Wszystko') ? 'initial' : 'none' }}>
                                        <div className="cat-carousel-card-inner-szkolenie">
                                            <div className="cat-carousel-card-img-szkolenie">
                                              {/* <p className="ybadge-szkolenie">Nowość!</p> */}
                                                <img src={kore} alt="" />
                                            </div>
                                            <div className="cat-carousel-card-title-szkolenie">
                                                <p>{t("Korekta lakieru od A do Z")}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="cat-carousel-card-szkolenie col-lg-3 col-md-3 col-sm-3" onClick={handleClickLsp} style={{display: ('Promo' === currentSelectedCat || currentSelectedCat === 'Wszystko') ? 'initial' : 'none' }}>
                                        <div className="cat-carousel-card-inner-szkolenie">
                                            <div className="cat-carousel-card-img-szkolenie">
                                                <img src={lsp} alt="" />
                                            </div>
                                            
                                            <div className="cat-carousel-card-title-szkolenie">
                                                <p>{t("Japońskie zabezpieczenie auta")}</p>
                                            </div>
                                        </div>
                                    </div>


                                    {/* <div className="cat-carousel-card-szkolenie col-lg-3 col-md-3 col-sm-3" onClick={handleClickPakiet} style={{display: ('Promo' === currentSelectedCat || currentSelectedCat === 'Wszystko') ? 'initial' : 'none' }}>
                                        <div className="cat-carousel-card-inner-szkolenie">
                                            <div className="cat-carousel-card-img-szkolenie">
                                                <img src={indy} alt="" />
                                            </div>
                                            <div className="cat-carousel-card-title-szkolenie">
                                                <p>Pakiet szkoleń</p>
                                            </div>
                                        </div>
                                    </div> */}

                                    <div className="cat-carousel-card-szkolenie col-lg-3 col-md-3 col-sm-3" onClick={handleClickIndywidualne} style={{display: ('Promo' === currentSelectedCat || currentSelectedCat === 'Wszystko') ? 'initial' : 'none' }}>
                                        <div className="cat-carousel-card-inner-szkolenie">
                                            <div className="cat-carousel-card-img-szkolenie">
                                                <img src={indy} alt="" />
                                            </div>
                                            <div className="cat-carousel-card-title-szkolenie">
                                                <p>{t("Szkolenie indywidualne")}</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="cat-carousel-card-szkolenie col-lg-3 col-md-3 col-sm-3" onClick={handleClickStaz} style={{display: ('Promo' === currentSelectedCat || currentSelectedCat === 'Wszystko') ? 'initial' : 'none' }}>
                                        <div className="cat-carousel-card-inner-szkolenie">
                                            <div className="cat-carousel-card-img-szkolenie">
                                                <img src={staz} alt="" />
                                            </div>
                                            <div className="cat-carousel-card-title-szkolenie">
                                                <p>Staż</p>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 col-sm-12 mob-cat-box">
                            <div className="cat-car-mob-wrapper row">
                                <div className="mob-cat-carousel-card col" onClick={handleClickJaponskie} style={{display: ('Promo' === currentSelectedCat || currentSelectedCat === 'Wszystko') ? 'initial' : 'none' }}>
                                    <div className="mob-cat-carousel-card-inner-szkolenie">
                                        <div className="mob-cat-carousel-card-img">
                                            <img src={japo} alt="" />
                                        </div>
                                        <div className="mob-cat-carousel-card-title">
                                            <p>{t("Japońskie mycie detailingowe")}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="mob-cat-carousel-card col" onClick={handleClickKorekta} style={{display: ('Promo' === currentSelectedCat || currentSelectedCat === 'Wszystko') ? 'initial' : 'none' }}>
                                    <div className="mob-cat-carousel-card-inner">
                                        <div className="mob-cat-carousel-card-img">
                                            <img src={kore} alt="" />
                                        </div>
                                        <div className="mob-cat-carousel-card-title">
                                            <p>{t("Korekta lakieru")}<br></br>{t(" od A do Z")}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="mob-cat-carousel-card col" onClick={handleClickLsp} style={{display: ('Promo' === currentSelectedCat || currentSelectedCat === 'Wszystko') ? 'initial' : 'none' }}>
                                    <div className="mob-cat-carousel-card-inner-szkolenie">
                                        <div className="mob-cat-carousel-card-img">
                                            <img src={lsp} alt="" />
                                        </div>
                                        <div className="mob-cat-carousel-card-title">
                                            <p>{t("Japońskie zabezpieczenie auta")}</p>
                                        </div>
                                    </div>
                                </div>



                                <div className="mob-cat-carousel-card col" onClick={handleClickIndywidualne} style={{display: ('Promo' === currentSelectedCat || currentSelectedCat === 'Wszystko') ? 'initial' : 'none' }}>
                                    <div className="mob-cat-carousel-card-inner">
                                        <div className="mob-cat-carousel-card-img">
                                            <img src={indy} alt="" />
                                        </div>
                                        <div className="mob-cat-carousel-card-title">
                                            <p>{t("Pakiet")}<br></br>{t(" szkoleń")}</p>
                                        </div>
                                    </div>
                                </div>
{/* 
                                <div className="mob-cat-carousel-card col" onClick={handleClickIndywidualne} style={{display: ('Promo' === currentSelectedCat || currentSelectedCat === 'Wszystko') ? 'initial' : 'none' }}>
                                    <div className="mob-cat-carousel-card-inner">
                                        <div className="mob-cat-carousel-card-img">
                                            <img src={indy} alt="" />
                                        </div>
                                        <div className="mob-cat-carousel-card-title">
                                            <p>Szkolenie<br></br> indywidualne</p>
                                        </div>
                                    </div>
                                </div> */}

                                {/* <div className="mob-cat-carousel-card col" onClick={handleClickStaz} style={{display: ('Promo' === currentSelectedCat || currentSelectedCat === 'Wszystko') ? 'initial' : 'none' }}>
                                    <div className="mob-cat-carousel-card-inner">
                                        <div className="mob-cat-carousel-card-img">
                                            <img src={staz} alt="" />
                                        </div>
                                        <div className="mob-cat-carousel-card-title">
                                            <p>Staż</p>
                                        </div>
                                    </div>
                                </div> */}

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            </div>
          {props.active === "main" && <Main />}
          {props.active === "japonskie" && <Japonskie />}
          {props.active === "korekta" && <Korekta />}
          {props.active === "indywidualne" && <Indywidualne />}
          {props.active === "staz" && <Staz />}
          {props.active === "lsp" && <Lsp />}
          {props.active === "pakiet" && <Pakiet />}
          <Footer />
        </section>
    )
};

export default Szkolenie;